// mds-dojo — dijit/_Contained — FAITHFUL port of references/dijit/_Contained.js.
// Codemod pipeline; declare from the faithful runtime; unused `registry` import
// dropped (getParent comes from _WidgetBase). Promoted to canonical.
// Mixin for widgets that are children of a container widget.
import declare from '../dojo/_base/declare-runtime';

export default declare('dijit._Contained', null, {
  _getSibling: function (which: string) {
    // Returns next or previous sibling.
    var p = this.getParent();
    return (p && p._getSiblingOfChild && p._getSiblingOfChild(this, which == 'previous' ? -1 : 1)) || null;
  },

  getPreviousSibling: function () {
    return this._getSibling('previous');
  },

  getNextSibling: function () {
    return this._getSibling('next');
  },

  getIndexInParent: function () {
    // Index of this widget within its container parent, or -1.
    var p = this.getParent();
    if (!p || !p.getIndexOfChild) {
      return -1;
    }
    return p.getIndexOfChild(this);
  },
});
